import { authAxios } from '@components/Auth';
import { API_V1_BASE } from '@config';
import { Garage } from '@models/BusinessPartner';
import { paginate, Pagination, PaginationParams } from '@models/Pagination';
import { snakes } from '@utils/lodash';

export type GarageNetworkSearchParams = PaginationParams & {
  search?: string;
  province?: string;
  insurerId?: string;
};

export class GarageNetworkApi {
  static getAll = async (params = {} as GarageNetworkSearchParams) => {
    return await authAxios
      .get(`${API_V1_BASE}/garage_networks`, { params: snakes(params) })
      .then((response) => paginate(response) as [Garage[], Pagination]);
  };
}
